/**
 * @type {{ [cacheGroupKey: string]: { [date: string]: import('../models/sessions').SearchApiEventSeries[] } }}
 */
const cache = {};

export const SessionsCache = {
  /**
   * @param {string} cacheGroupKey
   * @returns {string[]} Array of dates (e.g. '2025-07-24')
   */
  getDates(cacheGroupKey) {
    const cacheGroup = cache[cacheGroupKey];
    return cacheGroup ? Object.keys(cacheGroup) : [];
  },

  /**
   * @param {string} cacheGroupKey
   * @param {string} date
   * @returns {import('../models/sessions').SearchApiEventSeries[]}
   */
  get(cacheGroupKey, date) {
    return cache[cacheGroupKey]?.[date] || undefined;
  },

  /**
   * @param {string} cacheGroupKey
   * @param {string} date
   * @param {import('../models/sessions').SearchApiEventSeries[]} sessions
   */
  set(cacheGroupKey, date, sessions) {
    if (!cache[cacheGroupKey]) {
      cache[cacheGroupKey] = {};
    }
    cache[cacheGroupKey][date] = sessions;
  },
};

/**
 * Clears all cached data. This function is intended for use ONLY in tests
 * to ensure a clean state between test runs. It should never be called
 * in production code as it will clear all cached sessions data.
 */
export function _testResetCache() {
  Object.keys(cache).forEach((key) => {
    delete cache[key];
  });
}
